export default __webpack_public_path__ + "static/media/applied.a2af5d57.svg";